module.exports = __webpack_public_path__ + "static/assets/40ed288c687ce245b74779771e16a9d1.png";